<div class="form-element">
  <p-select
    dndDropzone
    (onChange)="props.onChangeEvent?.(field, $event)"
    (onBlur)="props.onBlur?.($event)"
    (onFocus)="props.onFocus?.($event)"
    (onClick)="props.onClick?.($event)"
    (onHide)="props.onHide?.($event)"
    (onShow)="props.show?.($event)"
    (onFilter)="props.onFilterChange?.($event)"
    [formControl]="formControl"
    [class.readonly]="props.readonly"
    [class.required]="props.required"
    [filterBy]="props.filterBy"
    [appendTo]="props.appendTo"
    [filterPlaceholder]="props.filterPlaceholder"
    [filter]="props.filter"
    [emptyMessage]="props.emptyMessage || ('table.no_results' | translate)"
    [emptyFilterMessage]="props.emptyFilterMessage || ('table.no_results' | translate)"
    [optionLabel]="props.optionLabel"
    [options]="props.options | observablePipe | async | sortAlphabetically: props.sortAlphabetically : props.sortBy"
    [panelStyleClass]="panelStyleClass"
    [panelStyle]="props.panelStyle"
    [editable]="props.editable"
    [placeholder]="props.placeholder"
    [scrollHeight]="props.scrollHeight"
    [resetFilterOnHide]="props.resetFilterOnHide"
    [showClear]="props.showClear"
    [group]="props.group"
    [styleClass]="styleClass"
    [virtualScroll]="props.virtualScroll"
    [virtualScrollItemSize]="props.virtualScrollItemSize"
    [disabled]="props.disabled"
    [dropdownIcon]="props.dropdownIcon"
    [readonly]="props.readonly"
    [optionValue]="props.optionValue"
    [tabindex]="!props.disabled ? props.tabindex || 0 : -1"
    [autofocus]="props.autofocus"
    [autofocusFilter]="props.autofocusFilter"
    [style]="props.style"
    [dndDisableDropIf]="!props.droppable"
    (dndDrop)="onDrop($event)" />
</div>
